import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAsterisk = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 6,
	height: 5,
	viewBox: "0 0 6 5",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M5.028 2.268L3.192 2.664L4.44 4.056L3.576 4.692L2.628 3.084L1.692 4.692L0.828 4.068L2.064 2.664L0.24 2.268L0.564 1.284L2.268 2.016L2.088 0.132H3.168L2.988 2.028L4.692 1.272L5.028 2.268Z",
		fill: "#CC0000"
	})]
});
const ForwardRef = forwardRef(SvgAsterisk);
export { ForwardRef as ReactComponent };
